var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"logo-container"},[_c('img',{staticClass:"thumbnail",attrs:{"alt":"InvestCalc","src":require("../assets/WRE_logo.png")}}),_c('button',{staticClass:"get-started-btn",on:{"click":_vm.goToCalcPage}},[_vm._v("Get Started")])]),_c('HomePage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }